import { Component, OnInit, ViewChild } from '@angular/core';
import { AppInformationService, ArkUnitOfWork, AuthService } from 'app/core/core.module';
import { DxDataGridComponent } from 'devextreme-angular';
import moment from 'moment';

@Component({
    selector: 'app-online-giving-search',
    templateUrl: './online-giving-search.component.html',
    styleUrls: ['./online-giving-search.component.scss'],
    standalone: false,
})
export class OnlineGivingSearchComponent implements OnInit {
    batches: any[] = [];
    reviewOnly = false;
    generalFund: any[] = [];
    dataSource: any[] = [];
    selectedAmount: number;
    givings: any;
    bankAmounts: any;
    types: any;

    filter: any;

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
    @ViewChild('givingGrid') givingGrid: DxDataGridComponent;

    constructor(
        private uow: ArkUnitOfWork,
        private auth: AuthService,
        public appInfo: AppInformationService
    ) {}

    async ngOnInit() {
        this.filter = {};
        this.reviewOnly = this.appInfo.graafschap && this.auth.hasRole('Secretary');
        this.types = await this.uow.bankTransactionTypes.all();
        const start = moment(new Date()).add(-3,'years').toDate();
        const end = new Date();
        this.appInfo.pleaseWaitShow();
        this.givings = await this.uow.onlineGivings.all();
        this.bankAmounts = await this.uow.bankTransactions.all();
        this.bankAmounts.forEach((bankAmount) => {
            bankAmount.amount = !!bankAmount.credit ? bankAmount.credit : bankAmount.debit ? bankAmount.debit * -1 : 0;
        });
        this.appInfo.pleaseWaitHide();

    }

    onSelectionChanged(e) {
        const rows = this.dataGrid.instance.getSelectedRowsData();
        this.selectedAmount = 0;
        rows.forEach(row => {
            this.selectedAmount += row.amount;
        });
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                template: 'toolbarText',
                location: 'before',
            },
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            // {
            //     widget: 'dxButton',
            //     options: {
            //         icon: 'revert',
            //         elementAttr: { title: 'Reset Filters' },
            //         onClick: () => {
            //             e.component.clearFilter();
            //         },
            //     },
            //     location: 'after',
            // },
            {
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    },
                },
                location: 'after',
            }
        );
    }

    // add() {
    //     const modalRef = this.modalService.show(BatchEditDialogComponent, {
    //         class: 'modal-md',
    //         ignoreBackdropClick: true,
    //         keyboard: false,
    //         initialState: { routerOption: 'new' },
    //     });

    //     modalRef.content.result.subscribe(async (result) => {
    //         if (result.result) {
    //             this.open(result.batchId);
    //             this.dataGrid.instance.refresh();
    //         }
    //     });
    // }

    // async open(batchId: number) {
    //     if (!batchId) return;
    //     if (batchId) this.router.navigate(['/giving/batches/' + batchId]);
    // }
}
